import 'es6-promise/auto'
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment  from 'moment';
//import './registerServiceWorker.js';

import Editor from '@tinymce/tinymce-vue'



import './scss/app.scss';
import $ from 'jquery';
global.$ = $;
import 'bootstrap';
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(Editor);
library.add(fas, far)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import 'datatables.net';
import 'datatables.net-bs4';

$.extend($.fn.dataTable.defaults,
    {
       
        "language": {

            "sEmptyTable": "Nessun elemento trovato",
            "sInfo": "Vista da _START_ a _END_ di _TOTAL_ elementi",
            "sInfoEmpty": "Vista da 0 a 0 di 0 elementi",
            "sInfoFiltered": "(filtrati da _MAX_ elementi totali)",
            "sInfoPostFix": "",
            "sInfoThousands": ".",
            "sLengthMenu": "Visualizza _MENU_ elementi",
            "sLoadingRecords": "Caricamento...",
            "sProcessing": "Elaborazione...",
            "sSearch": "Cerca:",
            "sZeroRecords": "La ricerca non ha portato alcun risultato.",
            "oPaginate": {
                "sFirst": "Inizio",
                "sPrevious": "Precedente",
                "sNext": "Successivo",
                "sLast": "Fine"
            },
            "oAria": {
                "sSortAscending": ": attiva per ordinare la colonna in ordine crescente",
                "sSortDescending": ": attiva per ordinare la colonna in ordine decrescente"
            }
        }

    }
);

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.use(VueLodash, { lodash: lodash })

import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';


import vSelect from 'vue-select'
import 'vue-select/dist/vue-select';

Vue.component('v-select', vSelect)

Vue.use(VueSweetalert2);

import axios from 'axios'

import axiosConfig from './axios';


//import i18n from './i18n';

import VeeValidateIT from 'vee-validate/dist/locale/it';
import VeeValidate, { Validator } from 'vee-validate';

Vue.use(VeeValidate, {
  events: 'change'
});


VeeValidateIT.messages.date_format = function (field, f) { return `Il campo ${field} non riconosciuto.`; }
Validator.localize('it', VeeValidateIT);


Vue.config.productionTip = false;

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
    }
});

Vue.filter('reportname', function (value) {
    if (value) {
        return value+"_"+moment().format('YYYYMMDD')+".xlsx";
    }
});



Vue.filter('state', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
        return `${window.SETTINGS.states[value].description}`
    }
    return "";
});

Vue.filter('stateCss', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
        return `${window.SETTINGS.states[value].cssClass}`
    }
    return "";
});

Vue.filter('stateTextCss', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
        return `text-${window.SETTINGS.states[value].cssClass}`
    }
    return "";
});

Vue.filter('statebadge', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
      
        return `<span class="badge badge-${window.SETTINGS.states[value].cssClass}">${window.SETTINGS.states[value].description}</span>`
      
    }
    return "";
});



Vue.filter('formatHour', function (value) {
    if (value) {
        return moment(String(value)).format('HH:mm');
    }
});

Vue.filter('formatFullDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm');
    }
});

Vue.filter('toCurrency', function (value) {
   
    return "€ " + value.toFixed(2).replace('.',',');
});
Vue.filter('attachemntUrl', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.attachmentUrl) {
        return `${window.SETTINGS.attachmentUrl}/${value}`;
    }
    return "#";
});
Vue.filter('documentUrl', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.documentUrl) {
        return `${window.SETTINGS.documentUrl}/${value}`;
    }
    return "#";
});
Vue.filter('attachemntTempUrl', function (value, o) {
    if (value && window.SETTINGS && window.SETTINGS.attachmentUrl) {
        return `${window.SETTINGS.attachmentUrl}?filename=${value}&originalFileName=${o}`;
    }
    return "#";
   
});
Vue.prototype.$filters = Vue.options.filters;



window.SETTINGS = {
    "apiUrl": "http://localhost:5000/api",
    "isStaging":false,
    "attachmentUrl": "http://localhost:5000/attachment",
    "roles": ["administrator", "operator", "user", "admininstrative", "superoperator", "superuser"],
    "states": {
        "None": {
            "description": "",
            "cssClass": "warning d-none"
        },
        "Open": {
            "description": "Da prendere in carico",
            "cssClass": "warning"
        },
        "InCharge": {
            "description": "Da riscontrare",
            "cssClass": "warning"
        },
        "Verified": {
            "description": "Pro-forma acconto da inviare",
            "cssClass": "info"
        },
        "DownPaymentWaiting": {
            "description": "Attesa pagamento acconto",
            "cssClass": "info"
        },
        "DownPaymentPaid": {
            "description": "Acconto pagato",
            "cssClass": "info"
        },
        "DocumentationWaiting": {
            "description": "In attesa della documentazione",
            "cssClass": "info"
        },
        "DocumentationOk": {
            "description": "Documentazione completa",
            "cssClass": "info"
        },
        "PaymentWaiting": {
            "description": "In attesa del pagamento a saldo",
            "cssClass": "info"
        },

        "Payed": {
            "description": "Pagamento ricevuto",
            "cssClass": "info"
        },

        "Sent": {
            "description": "Evasa",
            "cssClass": "success"
        },
        "Processed": {
            "description": "Inviata",
            "cssClass": "success"
        },

        "KO": {
            "description": "Annullata",
            "cssClass": "danger"
        }
    } 
}


switch (process.env.NODE_ENV) {
    case 'production':
        axios.get('settings').then(result => {
            Object.assign(window.SETTINGS, result.data);

          
            store.commit('setEnvironment', window.SETTINGS.isStaging);
         
            axiosConfig();
            Mount();
        }).catch()
        break;

    default:
        axios.get('http://localhost:5000/settings').then(result => {
            Object.assign(window.SETTINGS, result.data);
        
            store.commit('setEnvironment', window.SETTINGS.isStaging );
            axiosConfig();
            Mount();
        }).catch()
        axiosConfig();
        Mount();
        break;
}


function Mount() {
    new Vue({
        router,
        store,
        //i18n,
        render: h => h(App)
    }).$mount('#app');
}
